/**
 * Links
 */

export const FINRA_LINK = 'https://www.finra.org/#/'

export const SIPC_LINK = 'https://www.sipc.org/'
